import MoviesList from '@/views/pages/movie-list.vue';
import Movie from '@/views/pages/movie.vue';
import store from '../store/index.js';

export default [
  {
    component: MoviesList,
    // component: () => import(/* webpackChunkName: "login" */ '@/views/pages/auth-pages/login/login.vue'),
    path: '/',
    name: 'Home',
    props: true
  },
  {
    component: MoviesList,
    // component: () => import(/* webpackChunkName: "login" */ '@/views/pages/auth-pages/recovery-password/recovery-password.vue'),
    path: '/movies',
    name: 'MoviesList',
    props: true
  },
  {
    component: Movie,
    path: '/movie/:title',
    props: true,
    children: [
      {
        component: () => import(/* webpackChunkName: "ticketing" */ '@/views/pages/booking.vue'),
        path: '',
        name: 'booking',
        beforeEnter: (to, from, next) => {
          store.dispatch('levelChanged', 1);
          next();
        }
      },
      {
        component: () => import(/* webpackChunkName: "ticketing" */ '@/views/pages/tickets.vue'),
        path: 'tickets',
        name: 'tickets',
        beforeEnter: (to, from, next) => {
          store.dispatch('levelChanged', 2);
          if (store.getters['ticketing/selectedShow']) {
            next();
          } else {
            next({ name: 'booking', params: { title: to.params.title } });
          }
        }
      },
      {
        component: () => import(/* webpackChunkName: "ticketing" */ '@/views/pages/seats.vue'),
        path: 'seats',
        name: 'seats',
        beforeEnter: (to, from, next) => {
          store.dispatch('levelChanged', 3);
          next();
          // if (store.getters['ticketing/totalTicketCount']) {
          //   next();
          // } else {
          //   next({name: 'tickets', params: { title: to.params.title }});
          // }
        }
      },
      {
        component: () => import(/* webpackChunkName: "ticketing" */ '@/views/pages/payment.vue'),
        path: 'payment',
        name: 'payment',
        beforeEnter: (to, from, next) => {
          store.dispatch('levelChanged', 4);
          if (store.getters['ticketing/holdId']) {
            next();
          } else {
            next({ name: 'seats', params: { title: to.params.title } });
          }
        }
      },
      {
        component: () => import(/* webpackChunkName: "ticketing" */ '@/views/pages/review.vue'),
        path: 'review',
        name: 'review',
        beforeEnter: (to, from, next) => {
          store.dispatch('levelChanged', 5);
          const pd = store.getters['ticketing/paymentData'];
          if (pd && pd.firstName) {
            next();
          } else {
            next({ name: 'seats', params: { title: to.params.title } });
          }
        }
      }
    ]
  }
];
